import { render, staticRenderFns } from "./ModuleProductShopping.vue?vue&type=template&id=7b00ee43&scoped=true&lang=html"
import script from "./ModuleProductShopping.vue?vue&type=script&lang=js"
export * from "./ModuleProductShopping.vue?vue&type=script&lang=js"
import style0 from "./ModuleProductShopping.vue?vue&type=style&index=0&id=7b00ee43&prod&lang=css"
import style1 from "./ModuleProductShopping.vue?vue&type=style&index=1&id=7b00ee43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b00ee43",
  null
  
)

export default component.exports